import React, { useEffect, useState } from "react";
import { performance } from "../../data";
import { RxSlash } from "react-icons/rx";
import Answer from "./Answer";
import Input from "../Input";

const ReadOnlyMarksPerformance = ({ data: evaluatedData, sectionRefs }) => {
  const sections = performance.sections;
  const sectionData = performance.sectionData;

  return (
    <div className="col-md-9">
      <div>
        {/* BEGIN: TRAINING & ENABLEMENT */}
        <section id={sections[0]} ref={sectionRefs?.[sections[0]]}>
          <div className="card">
            <h2 className="heading">{sections[0]}</h2>
            <p>
              <span className="d-block">
                {sectionData[sections[0]].description}
              </span>
            </p>

            <div className="d-f f-w inputs gap-15">
              <div className="input-group">
                <label htmlFor="certifications" className="question">
                  {sectionData[sections[0]].questions[0]}
                </label>
                <Answer className="performance-qa-answer-cert">
                  <div
                    id="certifications"
                    className="d-flex flex-column gap-4 w-100"
                  >
                    {/* Associate Certifications */}
                    <div className="performance-cert-category-wrapper">
                      <div className="performance-cert-category">
                        <label
                          htmlFor="associate-certifications"
                          className="text-black-50"
                        >
                          Associate
                        </label>
                        <div>
                          <div className="performance-item-wrapper">
                            {evaluatedData.certifications.associate.answer.map(
                              (item, index) => (
                                <span
                                  className="performance-item"
                                  key={`associate-${index}`}
                                >
                                  {item}
                                </span>
                              )
                            )}
                          </div>
                        </div>
                      </div>
                      <ComputedMarks
                        value={evaluatedData.certifications.associate.marks}
                      />
                    </div>
                    {/* Administrator Certifications */}
                    <div className="performance-cert-category-wrapper">
                      <div className="performance-cert-category">
                        <label
                          htmlFor="associate-certifications"
                          className="text-black-50"
                        >
                          Administrator
                        </label>
                        <div className="performance-item-wrapper">
                          {" "}
                          {evaluatedData.certifications.administrator.answer.map(
                            (item, index) => (
                              <span
                                className="performance-item"
                                key={`administrator-${index}`}
                              >
                                {item}
                              </span>
                            )
                          )}
                        </div>
                      </div>
                      <ComputedMarks
                        value={evaluatedData.certifications.administrator.marks}
                      />
                    </div>
                    {/* Architect Certifications */}
                    <div className="performance-cert-category-wrapper">
                      <div className="performance-cert-category">
                        <label
                          htmlFor="associate-certifications"
                          className="text-black-50"
                        >
                          Architect
                        </label>
                        <div className="performance-item-wrapper">
                          {evaluatedData.certifications.architect.answer.map(
                            (item, index) => (
                              <span
                                className="performance-item"
                                key={`architect-${index}`}
                              >
                                {item}
                              </span>
                            )
                          )}
                        </div>
                      </div>
                      <ComputedMarks
                        value={evaluatedData.certifications.architect.marks}
                      />
                    </div>
                    {/* Consultant Certifications */}
                    <div className="performance-cert-category-wrapper">
                      <div className="performance-cert-category">
                        <label
                          htmlFor="associate-certifications"
                          className="text-black-50"
                        >
                          Associate
                        </label>
                        <div className="performance-item-wrapper">
                          {evaluatedData.certifications.consultant.answer.map(
                            (item, index) => (
                              <span
                                className="performance-item"
                                key={`consultant-${index}`}
                              >
                                {item}
                              </span>
                            )
                          )}
                        </div>
                      </div>
                      <ComputedMarks
                        value={evaluatedData.certifications.consultant.marks}
                      />
                    </div>
                    {/* Developer Certifications */}
                    <div className="performance-cert-category-wrapper">
                      <div className="performance-cert-category">
                        <label
                          htmlFor="associate-certifications"
                          className="text-black-50"
                        >
                          Developer
                        </label>
                        <div className="performance-item-wrapper">
                          {evaluatedData.certifications.developer.answer.map(
                            (item, index) => (
                              <span
                                className="performance-item"
                                key={`developer-${index}`}
                              >
                                {item}
                              </span>
                            )
                          )}
                        </div>
                      </div>
                      <ComputedMarks
                        value={evaluatedData.certifications.developer.marks}
                      />
                    </div>
                  </div>
                </Answer>
              </div>
            </div>

            <div className="d-f f-w inputs gap-15">
              <div className="input-group">
                <label className="question" htmlFor="otherCertifications">
                  {sectionData[sections[0]].questions[1]}
                </label>
                <Answer className="performance-qa-read-only-marks-answer">
                  {evaluatedData.otherCertifications.answer}
                  <ComputedMarks
                    value={evaluatedData.otherCertifications.marks}
                  />
                </Answer>
              </div>
            </div>

            <div className="d-f f-w inputs gap-15">
              <div className="input-group">
                <label htmlFor="exercisesCompleted" className="question">
                  {sectionData[sections[0]].questions[2]}
                </label>
                <Answer className="performance-qa-read-only-marks-answer">
                  <div className="performance-item-wrapper">
                    {evaluatedData.exercisesCompleted.answer.map(
                      (item, index) => (
                        <span
                          className="performance-item"
                          key={`exercisesCompleted-${index}`}
                        >
                          {item}
                        </span>
                      )
                    )}
                  </div>
                  <ComputedMarks
                    value={evaluatedData.exercisesCompleted.marks}
                  />
                </Answer>
              </div>
            </div>

            <div className="d-f f-w inputs gap-15">
              <div className="input-group">
                <label className="question" htmlFor="mockInterviewsGiven">
                  {sectionData[sections[0]].questions[3]}
                </label>
                <Answer className="performance-qa-read-only-marks-answer">
                  {evaluatedData.mockInterviewsGiven.answer}{" "}
                  <ComputedMarks
                    value={evaluatedData.mockInterviewsGiven.marks}
                  />
                </Answer>
              </div>
            </div>

            <div className="d-f f-w inputs gap-15">
              <div className="input-group">
                <label className="question" htmlFor="mockInterviewDetails">
                  {sectionData[sections[0]].questions[4]}
                </label>
                <Answer className="performance-qa-read-only-marks-answer">
                  {evaluatedData.mockInterviewDetails.answer}
                  <ComputedMarks
                    value={evaluatedData.mockInterviewDetails.marks}
                  />
                </Answer>
              </div>
            </div>

            <div className="d-f f-w inputs gap-15">
              <div className="input-group">
                <label
                  className="question"
                  htmlFor="expertLedSessionsPresented"
                >
                  {sectionData[sections[0]].questions[5]}
                </label>
                <Answer className="performance-qa-read-only-marks-answer">
                  {evaluatedData.expertLedSessionsPresented.answer}
                  <ComputedMarks
                    value={evaluatedData.expertLedSessionsPresented.marks}
                  />
                </Answer>
              </div>
            </div>

            <div className="d-f f-w inputs gap-15">
              <div className="input-group">
                <label className="question" htmlFor="coffeeNLearnSessions">
                  {sectionData[sections[0]].questions[6]}
                </label>
                <Answer className="performance-qa-read-only-marks-answer">
                  {evaluatedData.coffeeNLearnSessions.answer}
                  <ComputedMarks
                    value={evaluatedData.coffeeNLearnSessions.marks}
                  />
                </Answer>
              </div>
            </div>

            <div className="d-f f-w inputs gap-15">
              <div className="input-group">
                <label className="question" htmlFor="isMuleSoftMeetupSpeaker">
                  {sectionData[sections[0]].questions[7]}
                </label>
                <Answer className="performance-qa-read-only-marks-answer">
                  {evaluatedData.isMuleSoftMeetupSpeaker.answer ? "Yes" : "No"}
                  <ComputedMarks
                    value={evaluatedData.isMuleSoftMeetupSpeaker.marks}
                  />
                </Answer>
              </div>
            </div>

            <div className="d-f f-w inputs gap-15">
              <div className="input-group">
                <label className="question" htmlFor="meetupDetails">
                  {sectionData[sections[0]].questions[8]}
                </label>
                <Answer className="performance-qa-read-only-marks-answer">
                  {evaluatedData.meetupDetails.answer}
                  <ComputedMarks value={evaluatedData.meetupDetails.marks} />
                </Answer>
              </div>
            </div>

            <div className="d-f f-w inputs gap-15">
              <div className="input-group">
                <label className="question" htmlFor="eventDetails">
                  {sectionData[sections[0]].questions[9]}
                </label>
                <Answer className="performance-qa-read-only-marks-answer">
                  {evaluatedData.eventDetails.answer}
                  <ComputedMarks value={evaluatedData.eventDetails.marks} />
                </Answer>
              </div>
            </div>

            <div className="d-f f-w inputs gap-15">
              <div className="input-group">
                <label className="question" htmlFor="isMuleSoftMeetupLeader">
                  {sectionData[sections[0]].questions[10]}
                </label>
                <Answer className="performance-qa-read-only-marks-answer">
                  {evaluatedData.isMuleSoftMeetupLeader.answer ? "Yes" : "No"}
                  <ComputedMarks
                    value={evaluatedData.isMuleSoftMeetupLeader.marks}
                  />
                </Answer>
              </div>
            </div>

            <div className="d-f f-w inputs gap-15 ">
              <div className="input-group">
                <label className="question" htmlFor="isMuleSoftMentor">
                  {sectionData[sections[0]].questions[11]}
                </label>
                <Answer className="performance-qa-read-only-marks-answer">
                  {evaluatedData.isMuleSoftMentor.answer ? "Yes" : "No"}
                  <ComputedMarks value={evaluatedData.isMuleSoftMentor.marks} />
                </Answer>
              </div>
            </div>

            <div className="d-f f-w inputs gap-15 ">
              <div className="input-group">
                <label className="question" htmlFor="isMuleSoftAmbassador">
                  {sectionData[sections[0]].questions[12]}
                </label>
                <Answer className="performance-qa-read-only-marks-answer">
                  {evaluatedData.isMuleSoftAmbassador.answer ? "Yes" : "No"}
                  <ComputedMarks
                    value={evaluatedData.isMuleSoftAmbassador.marks}
                  />
                </Answer>
              </div>
            </div>

            <div className="d-f f-w inputs gap-15 ">
              <div className="input-group">
                <label
                  className="question"
                  htmlFor="salesforceSessionsPresented"
                >
                  {sectionData[sections[0]].questions[13]}
                </label>
                <Answer className="performance-qa-read-only-marks-answer">
                  {evaluatedData.salesforceSessionsPresented.answer}
                  <ComputedMarks
                    value={evaluatedData.salesforceSessionsPresented.marks}
                  />
                </Answer>
              </div>
            </div>

            <div className="d-f f-w inputs gap-15">
              <div className="input-group">
                <label
                  className="question"
                  htmlFor="completedCaeliusAIEnablementProgram"
                >
                  {sectionData[sections[0]].questions[14]}
                </label>
                <Answer className="performance-qa-read-only-marks-answer">
                  {evaluatedData.completedCaeliusAIEnablementProgram.answer
                    ? "Yes"
                    : "No"}
                  <ComputedMarks
                    value={
                      evaluatedData.completedCaeliusAIEnablementProgram.marks
                    }
                  />
                </Answer>
              </div>
            </div>
          </div>
        </section>
        {/* END: TRAINING & ENABLEMENT */}

        {/* BEGIN: MENTORSHIP */}
        <section id={sections[1]} ref={sectionRefs?.[sections[1]]}>
          <div className="card">
            <h2 className="heading">{sections[1]}</h2>
            <p>
              <span className="d-block">
                {sectionData[sections[1]].description}
              </span>
            </p>

            <div className="d-f f-w inputs gap-15">
              <div className="input-group">
                <label className="question" htmlFor="trainingBuddyAssisted">
                  {sectionData[sections[1]].questions[0]}
                </label>
                <Answer className="performance-qa-read-only-marks-answer">
                  {evaluatedData.trainingBuddyAssisted.answer}
                  <ComputedMarks
                    value={evaluatedData.trainingBuddyAssisted.marks}
                  />
                </Answer>
              </div>
            </div>

            <div className="d-f f-w inputs gap-15">
              <div className="input-group">
                <label className="question" htmlFor="mentorLeadAssisted">
                  {sectionData[sections[1]].questions[1]}
                </label>
                <Answer className="performance-qa-read-only-marks-answer">
                  {evaluatedData.mentorLeadAssisted.answer}
                  <ComputedMarks
                    value={evaluatedData.mentorLeadAssisted.marks}
                  />
                </Answer>
              </div>
            </div>

            <div className="d-f f-w inputs gap-15">
              <div className="input-group">
                <label className="question" htmlFor="reviewsTaken">
                  {sectionData[sections[1]].questions[2]}
                </label>
                <Answer className="performance-qa-read-only-marks-answer">
                  {evaluatedData.reviewsTaken.answer}
                  <ComputedMarks value={evaluatedData.reviewsTaken.marks} />
                </Answer>
              </div>
            </div>
          </div>
        </section>
        {/* END: MENTORSHIP */}

        {/* BEGIN: PROJECTS */}
        <section id={sections[2]} ref={sectionRefs?.[sections[2]]}>
          <div className="card">
            <h2 className="heading">{sections[2]}</h2>
            <p>
              <span className="d-block">
                {sectionData[sections[2]].description}
              </span>
            </p>
            <div className="d-f f-w inputs gap-15">
              <div className="input-group">
                <label className="question" htmlFor="jobSkills">
                  {sectionData[sections[2]].questions[0]}
                </label>
                <Answer className="performance-qa-read-only-marks-answer">
                  {evaluatedData.projectsUndertaken.answer}
                  <ComputedMarks
                    value={evaluatedData.projectsUndertaken.marks}
                  />
                </Answer>
              </div>
            </div>

            <div className="d-f f-w inputs gap-15">
              <div className="input-group">
                <label className="question" htmlFor="projects">
                  {sectionData[sections[2]].questions[1]}
                </label>
                <Answer className="performance-qa-read-only-marks-answer">
                  {evaluatedData.projects.answer}
                  <ComputedMarks value={evaluatedData.projects.marks} />
                </Answer>
              </div>
            </div>

            <div className="d-f f-w inputs gap-15">
              <div className="input-group">
                <label className="question" htmlFor="codeReviewsTaken">
                  {sectionData[sections[2]].questions[2]}
                </label>
                <Answer className="performance-qa-read-only-marks-answer">
                  {evaluatedData.codeReviewsTaken.answer}
                  <ComputedMarks value={evaluatedData.codeReviewsTaken.marks} />
                </Answer>
              </div>
            </div>

            <div className="d-f f-w inputs gap-15">
              <div className="input-group">
                <label className="question" htmlFor="codeReviewsTakenArchitect">
                  {sectionData[sections[2]].questions[3]}
                </label>
                <Answer className="performance-qa-read-only-marks-answer">
                  {evaluatedData.codeReviewsTakenArchitect.answer}
                  <ComputedMarks
                    value={evaluatedData.codeReviewsTakenArchitect.marks}
                  />
                </Answer>
              </div>
            </div>

            <div className="d-f f-w inputs gap-15">
              <div className="input-group">
                <label
                  className="question"
                  htmlFor="architecturalSolutionsDesigned"
                >
                  {sectionData[sections[2]].questions[4]}
                </label>
                <Answer className="performance-qa-read-only-marks-answer">
                  {evaluatedData.architecturalSolutionsDesigned.answer}
                  <ComputedMarks
                    value={evaluatedData.architecturalSolutionsDesigned.marks}
                  />
                </Answer>
              </div>
            </div>

            <div className="d-f f-w inputs gap-15">
              <div className="input-group">
                <label className="question" htmlFor="achievements">
                  {sectionData[sections[2]].questions[5]}
                </label>
                <Answer className="performance-qa-read-only-marks-answer">
                  {evaluatedData.achievements.answer}
                  <ComputedMarks value={evaluatedData.achievements.marks} />
                </Answer>
              </div>
            </div>

            <div className="d-f f-w inputs gap-15">
              <div className="input-group">
                <label className="question" htmlFor="csatScore5Projects">
                  {sectionData[sections[2]].questions[6]}
                </label>
                <Answer className="performance-qa-read-only-marks-answer">
                  {evaluatedData.csatScore5Projects.answer}
                  <ComputedMarks
                    value={evaluatedData.csatScore5Projects.marks}
                  />
                </Answer>
              </div>
            </div>
          </div>
        </section>
        {/* END: PROJECTS */}

        {/* BEGIN: GENERAL */}
        <section id={sections[3]} ref={sectionRefs?.[sections[3]]}>
          <div className="card">
            <h2 className="heading">{sections[3]}</h2>
            <p>
              <span className="d-block">
                {sectionData[sections[3]].description}
              </span>
            </p>

            <div className="d-f f-w inputs gap-15">
              <div className="input-group">
                <label className="question" htmlFor="jobSkills">
                  {sectionData[sections[3]].questions[0]}
                </label>
                <Answer>{evaluatedData.selfAssessment.jobSkills.answer}</Answer>
              </div>
            </div>

            <div className="d-f f-w inputs gap-15">
              <div className="input-group">
                <label className="question" htmlFor="technicalSkills">
                  {sectionData[sections[3]].questions[1]}
                </label>
                <Answer>
                  {evaluatedData.selfAssessment.technicalSkills.answer}
                </Answer>
              </div>
            </div>

            <div className="d-f f-w inputs gap-15">
              <div className="input-group">
                <label className="question" htmlFor="responsiveness">
                  {sectionData[sections[3]].questions[2]}
                </label>
                <Answer>
                  {evaluatedData.selfAssessment.responsiveness.answer}
                </Answer>
              </div>
            </div>

            <div className="d-f f-w inputs gap-15">
              <div className="input-group">
                <label className="question" htmlFor="communicationSkills">
                  {sectionData[sections[3]].questions[3]}
                </label>
                <Answer>
                  {evaluatedData.selfAssessment.communicationSkills.answer}
                </Answer>
              </div>
            </div>

            <div className="d-f f-w inputs gap-15">
              <div className="input-group">
                <label className="question" htmlFor="teamwork">
                  {sectionData[sections[3]].questions[4]}
                </label>
                <Answer>{evaluatedData.selfAssessment.teamwork.answer}</Answer>
              </div>
            </div>

            <div className="d-f f-w inputs gap-15">
              <div className="input-group">
                <label className="question" htmlFor="flexibility">
                  {sectionData[sections[3]].questions[5]}
                </label>
                <Answer>
                  {evaluatedData.selfAssessment.flexibility.answer}
                </Answer>
              </div>
            </div>

            <div className="d-f f-w inputs gap-15">
              <div className="input-group">
                <label className="question" htmlFor="inclusiveness">
                  {sectionData[sections[3]].questions[6]}
                </label>
                <Answer>
                  {evaluatedData.selfAssessment.inclusiveness.answer}
                </Answer>
              </div>
            </div>

            <div className="d-f f-w inputs gap-15">
              <div className="input-group">
                <label className="question" htmlFor="initiative">
                  {sectionData[sections[3]].questions[7]}
                </label>
                <Answer>
                  {evaluatedData.selfAssessment.initiative.answer}
                </Answer>
              </div>
            </div>

            <div className="d-f f-w inputs gap-15">
              <div className="input-group">
                <label className="question" htmlFor="initiativeDetails">
                  {sectionData[sections[3]].questions[8]}
                </label>
                <Answer>{evaluatedData.initiativeDetails.answer}</Answer>
              </div>
            </div>
          </div>
        </section>
        {/* END: GENERAL */}

        {/* BEGIN: TRAINING REQUIREMENTS */}
        <section id={sections[4]} ref={sectionRefs?.[sections[4]]}>
          <div className="card">
            <h2 className="heading">{sections[4]}</h2>
            <p>
              <span className="d-block">
                {sectionData[sections[4]].description}
              </span>
            </p>

            <div className="d-f f-w inputs gap-15">
              <div className="input-group">
                <label className="question" htmlFor="trainingDevelopmentNeeds">
                  {sectionData[sections[4]].questions[0]}
                </label>
                <Answer>{evaluatedData.trainingDevelopmentNeeds.answer}</Answer>
              </div>
            </div>

            <div className="d-f f-w inputs gap-15">
              <div className="input-group">
                <label className="question" htmlFor="initiative">
                  {sectionData[sections[4]].questions[1]}
                </label>
                <Answer>{evaluatedData.additionalInfo.answer}</Answer>
              </div>
            </div>
          </div>
        </section>
        {/* END: TRAINING REQUIREMENTS */}
      </div>
    </div>
  );
};

const ComputedMarks = ({ value }) => {
  return <span className="performance-computed-marks">{value}</span>;
};

export default ReadOnlyMarksPerformance;
